import React, { useState, useEffect } from "react";
import { isIE, isEdge } from "react-device-detect";

const ImageSequence = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (isIE || isEdge) {
      setActiveIndex(images.length - 1);
    } else {
      const delay = activeIndex === 0 ? 1000 : 100;
      if (activeIndex < images.length - 1) {
        const timer = setTimeout(() => {
          setActiveIndex(activeIndex + 1);
        }, delay);
        return () => clearTimeout(timer);
      }
    }
  }, [images.length, activeIndex]);

  const renderedItems = images.map((image, index) => {
    const active = index === activeIndex ? " active" : "";
    return (
      <img
        alt="microsoft teams interface"
        id={index}
        className={`app-image ${active}`}
        key={index}
        src={require(`../images/${image}`)}
      />
    );
  });

  return renderedItems;
};

export default ImageSequence;
